<template>
	<div>
		<NcdTopContainer v-if="hasAccess() && !isLaptop" />
		<main class="guest-job-details" :class="hasAccess() ? 'login-detail' : ''">
			<section
				ref="job-details"
				class="jdprog-trans-main-cont"
				:class="{
					'mobmain-height-wennoacess': !hasAccess() && !isLaptop,
				}"
			>
				<div class="jdp-trans-overflow-2 w-100 pl-1">
					<div class="d-flex w-100 pl-3">
						<div style="height: 35px; width: 35px" v-if="jobShimmer">
							<b-skeleton class="h-100 w-100" type="avatar"></b-skeleton>
						</div>
						<template v-else>
							<div id="hideinmobile">
								<img
									src="../../assets/newdesign/jdprogress/trans-DP.svg"
									alt=""
								/>
							</div>
							<div id="hideinlaptop" class="mobjd-svg-back mr-2">
								<img
									src="../../assets/newdesign/jdprogress/mobjdprog/jdDP.svg"
									alt=""
								/>
							</div>
						</template>

						<div class="ml-3 width-94">
							<div
								class="d-flex align-items-start justify-content-between w-100"
							>
								<b-skeleton class="w-50" v-if="jobShimmer"></b-skeleton>
								<div
									class="jdp-black-txt-3 text-break w-60 mob-text-blue"
									v-else
								>
									{{ toTitleCase(selectedJob.title) }}
								</div>
								<div id="hideinlaptop" class="d-flex align-items-center gap-3">
									<img src="../../assets/newbuilder/share.svg" alt="" />
									<div
										@click.stop="
											!hasAccess()
												? openLoginModal()
												: toggleBookmark(selectedJob)
										"
									>
										<img
											v-if="selectedJob.bookmarked"
											class="pointer"
											src="../../assets/newdesign/jobsearch/filledBookmark.svg"
											alt=""
										/>
										<img
											v-else
											class="pointer"
											src="../../assets/newdesign/jobsearch/noFilledBookmard.svg"
											alt=""
										/>
									</div>
								</div>
								<div
									id="hideinmobile"
									class="d-flex align-items-center gap-3 pr-2"
									v-if="!jobShimmer"
								>
									<b-button
										style="width: 98px !important"
										class="candash-cancelBtn-js"
										@click="
											!hasAccess()
												? openLoginModal()
												: toggleBookmark(selectedJob)
										"
									>
										<img
											v-if="selectedJob.bookmarked"
											class="mr-2"
											src="../../assets/newdesign/jobsearch/button-bookmark-filled.svg"
											alt=""
										/>
										<img
											v-else
											class="mr-2"
											src="../../assets/newdesign/jobsearch/button-bookmark.svg"
											alt=""
										/>{{ selectedJob.bookmarked ? "Saved" : "Save" }}
									</b-button>
									<b-button
										v-if="
											!selectedJob.jobApplied && !selectedJob.addedByRecruiter
										"
										@click="
											!hasAccess()
												? openLoginModal()
												: selectedJob.customFields?.gov_job ||
												  selectedJob.customFields?.private_job
												? openGovtJobModal(selectedJob)
												: openApplyJobModal(selectedJob)
										"
										class="candash-addBtn-js"
										style="padding: 4px 18px !important"
									>
										Apply

										<img
											class="ml-2"
											src="../../assets/newdesign/jobsearch/whiteRightArrow.svg"
											alt=""
									/></b-button>
									<b-button
										v-else
										class="candash-addBtn-js"
										style="padding: 4px 18px !important"
									>
										<img
											class="mr-2"
											src="../../assets/newdesign/jobsearch/whiteDoubleTick.svg"
											alt=""
										/>
										Applied
									</b-button>
								</div>
							</div>
							<div id="hideinmobile">
								<b-skeleton class="w-33" v-if="jobShimmer"></b-skeleton>
								<div
									class="mt-2 text-truncate w-100 d-flex align-items-center"
									v-else
								>
									<div class="asp-grey-txt-5 w-80 e">
										{{
											selectedJob.customFields?.private_job
												? selectedJob.customFields?.Board_Organization
												: selectedJob.customerName
										}}
									</div>
									<div
										class="w-20 d-flex justify-content-end"
										v-if="selectedJob.customFields?.gov_job"
									>
										<div class="ja-govtjob-tag">
											<img
												src="@/assets/job-search-icons/govt-tag.svg"
												class="mr-1"
												alt=""
											/>Government Job
										</div>
									</div>
								</div>
								<b-skeleton class="w-50" v-if="jobShimmer"></b-skeleton>
								<div
									class="cd-hs-pi-sh-2 d-flex align-items-start mt-2 gap-3"
									v-else
								>
									<div
										class="d-flex align-items-center"
										v-if="selectedJob.experienceRequired"
									>
										<img
											class="mr-1"
											src="../../assets/newdesign/dashboard/blueMail2.svg"
											alt=""
										/>{{
											selectedJob.experienceRequired === "others"
												? "12+"
												: selectedJob.experienceRequired
										}}
										Years
									</div>
									<div
										class="d-flex align-items-center"
										v-if="selectedJob.jobType"
									>
										<img
											class="mr-1"
											src="../../assets/newdesign/jdprogress/trans-fulltime.svg"
											alt=""
										/>{{ toTitleCase(selectedJob.jobType) }}
									</div>
									<div class="d-flex align-items-center max-w60 text-break">
										<img
											class="mr-1"
											src="../../assets/newdesign/jdprogress/trans-location.svg"
											alt=""
										/>
										<span v-if="!showAllLocations">
											{{
												selectedJob.location?.length > 0
													? selectedJob.location[0]
													: ""
											}}
											<span
												v-if="selectedJob.location?.length > 1"
												@click="showAllLocations = true"
												class="viewmore-grey ml-1 pointer"
												>+{{ selectedJob.location.length - 1 }} more</span
											>
										</span>
										<span v-else
											>{{ selectedJob.location.join(", ") }}
											<span
												@click="showAllLocations = false"
												class="viewmore-grey ml-1 pointer"
												>Show less</span
											>
										</span>
									</div>
								</div>
								<b-skeleton class="w-80" v-if="jobShimmer"></b-skeleton>
								<div v-else class="d-flex justify-content-between">
									<div class="d-flex align-items-start cd-hs-pi-sh-2 mt-2 mr-3">
										<span class="mobjd-light-grey-txt mr-1">
											<img
												src="../../assets/newdesign/jdprogress/skills.svg"
												alt=""
										/></span>
										<span v-if="selectedJob.skills?.length > 0">
											{{
												showAllSkills
													? selectedJob.skills.join(", ")
													: selectedJob.skills.slice(0, 4).join(", ")
											}}
											<span
												v-if="selectedJob.skills?.length > 4 && !showAllSkills"
												@click="showAllSkills = true"
												class="viewmore-grey ml-1 pointer"
												>+{{ selectedJob.skills.length - 4 }} more</span
											>
											<span
												v-if="selectedJob.skills?.length > 4 && showAllSkills"
												@click="showAllSkills = false"
												class="viewmore-grey ml-1 pointer"
												>less</span
											>
										</span>
										<span v-else class="text-d9d9d9">Not Mentioned</span>
									</div>
									<div
										class="d-flex align-items-start mb-grey-txt mt-2 mr-2 white-space-no-wrap"
									>
										<img
											class="mr-1"
											src="../../assets/newdesign/jdprogress/trans-posted.svg"
											alt=""
										/>{{ selectedJob.postedAt }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div id="hideinlaptop">
						<b-skeleton class="w-33" v-if="jobShimmer"></b-skeleton>
						<div
							class="mt-2 text-truncate w-100 d-flex align-items-center"
							v-else
						>
							<div class="asp-grey-txt-5 w-80 e">
								{{
									selectedJob.customFields?.private_job
										? selectedJob.customFields?.Board_Organization
										: selectedJob.customerName
								}}
							</div>
							<div
								class="w-20 d-flex justify-content-end"
								v-if="selectedJob.customFields?.gov_job"
							>
								<div class="ja-govtjob-tag">
									<img
										src="@/assets/job-search-icons/govt-tag.svg"
										class="mr-1"
										alt=""
									/>Government Job
								</div>
							</div>
						</div>
						<b-skeleton class="w-50" v-if="jobShimmer"></b-skeleton>
						<div
							class="cd-hs-pi-sh-2 d-flex align-items-start mt-2 gap-3"
							v-else
						>
							<div
								class="d-flex align-items-center"
								v-if="selectedJob.experienceRequired"
							>
								<img
									class="mr-1"
									src="../../assets/newdesign/dashboard/blueMail2.svg"
									alt=""
								/>{{
									selectedJob.experienceRequired === "others"
										? "12+"
										: selectedJob.experienceRequired
								}}
								Years
							</div>
							<div class="d-flex align-items-center" v-if="selectedJob.jobType">
								<img
									class="mr-1"
									src="../../assets/newdesign/jdprogress/trans-fulltime.svg"
									alt=""
								/>{{ toTitleCase(selectedJob.jobType) }}
							</div>
							<div class="d-flex align-items-center max-w60 text-break">
								<img
									class="mr-1"
									src="../../assets/newdesign/jdprogress/trans-location.svg"
									alt=""
								/>
								<span v-if="!showAllLocations">
									{{
										selectedJob.location?.length > 0
											? selectedJob.location[0]
											: ""
									}}
									<span
										v-if="selectedJob.location?.length > 1"
										@click="showAllLocations = true"
										class="viewmore-grey ml-1 pointer"
										>+{{ selectedJob.location.length - 1 }} more</span
									>
								</span>
								<span v-else>
									{{ selectedJob.location.join(", ") }}
									<span
										@click="showAllLocations = false"
										class="viewmore-grey ml-1 pointer"
										>less</span
									>
								</span>
							</div>
						</div>
						<b-skeleton class="w-80" v-if="jobShimmer"></b-skeleton>
						<div v-else>
							<div class="d-flex align-items-start cd-hs-pi-sh-2 mt-2 mr-3">
								<span class="mobjd-light-grey-txt mr-1">Skills :</span>
								<span v-if="selectedJob.skills?.length > 0">
									{{
										showAllSkills
											? selectedJob.skills.join(", ")
											: selectedJob.skills.slice(0, 4).join(", ")
									}}
									<span
										v-if="selectedJob.skills?.length > 4 && !showAllSkills"
										@click="showAllSkills = true"
										class="viewmore-grey ml-1 pointer"
										>+{{ selectedJob.skills.length - 4 }} more</span
									>
									<span
										v-if="selectedJob.skills?.length > 4 && showAllSkills"
										@click="showAllSkills = false"
										class="viewmore-grey ml-1 pointer"
										>less</span
									>
								</span>
								<span v-else class="text-d9d9d9">Not Mentioned</span>
							</div>
							<div
								class="d-flex align-items-start mb-grey-txt mt-2 mr-2 white-space-no-wrap"
							>
								<img
									class="mr-1"
									src="../../assets/newdesign/jdprogress/trans-posted.svg"
									alt=""
								/>{{ selectedJob.postedAt }}
							</div>
						</div>
					</div>
					<section
						class="jobapply-box d-flex align-items-center mt-3"
						v-if="getgovtids.includes(selectedJob.jobID)"
					>
						<div class="w-84">
							<div class="mb-black-bold-4">Did you Apply?</div>
							<div class="jobapplysubtext">
								Let us know and we will help you track your application
							</div>
						</div>
						<div class="w-8 text-center">
							<div
								class="jobapplybox-btns pointer"
								@click="appliedGovtjob(selectedJob.jobID)"
							>
								Yes
							</div>
						</div>
						<div class="w-8 text-center">
							<div
								class="jobapplybox-btns pointer"
								@click="removeGovtid(selectedJob.jobID)"
							>
								No
							</div>
						</div>
					</section>
					<b-skeleton class="w-33 mt-3" v-if="jobShimmer"></b-skeleton>
					<div class="mb-black-bold-4 my-4" v-else>Job Description</div>
					<b-skeleton class="w-100 h-30 mt-3" v-if="jobShimmer"></b-skeleton>
					<div
						v-else
						class="mb-grey-txt-2 pr-3 mb-2"
						v-html="selectedJob.description"
					></div>
					<template v-if="jobShimmer">
						<div class="d-flex w-100 justify-content-between">
							<div class="w-50">
								<b-skeleton class="w-33 mt-3"></b-skeleton>
								<b-skeleton class="w-50 mt-3"></b-skeleton>
							</div>
							<div class="w-50">
								<b-skeleton class="w-33 mt-3"></b-skeleton>
								<b-skeleton class="w-50 mt-3"></b-skeleton>
							</div>
						</div>
						<hr class="hr-back" />
						<div class="d-flex w-100 justify-content-between">
							<div class="w-50">
								<b-skeleton class="w-33 mt-3"></b-skeleton>
								<b-skeleton class="w-50 mt-3"></b-skeleton>
							</div>
							<div class="w-50">
								<b-skeleton class="w-33 mt-3"></b-skeleton>
								<b-skeleton class="w-50 mt-3"></b-skeleton>
							</div>
						</div>
					</template>
					<template v-if="!jobShimmer">
						<template v-if="selectedJob.skillsToLearn?.length > 0">
							<div
								class="d-flex align-items-center justify-content-between mt-4"
							>
								<div class="mb-black-bold">
									Skills you need to prepare on for this Job:
								</div>
								<div class="d-flex align-items-center jdp-blue-txt-2 mr-2">
									Gathered by Hire3x
									<img
										class="ml-1"
										src="../../assets/newdesign/jdprogress/trans-AI.svg"
										alt
									/>
								</div>
							</div>
							<div class="jdp-italic-text-2">
								Increase your chances of getting hired by 2x
							</div>
							<div class="d-flex flex-wrap mt-1">
								<div
									v-for="(skill, index) in selectedJob.skillsToLearn"
									:key="index"
									class="jdp-skill-tag mr-2 mb-2"
								>
									{{ skill }}
								</div>
							</div>
						</template>
					</template>

					<template
						v-if="
							(!relatedAssessments || relatedAssessments.length) &&
							!jobShimmer &&
							!selectedJob.customFields?.gov_job
						"
					>
						<div class="mb-black-bold mt-3">
							Assessments to practice for this job
						</div>
						<div
							v-if="!relatedAssessments"
							class="d-flex mt-2"
							:class="{
								'flex-column': !isLaptop,
							}"
						>
							<AssessmentCardSkeleton
								v-for="assess in 2"
								:key="assess"
								customClass="shimmermobileasmntcard carousel-assesspro-cards-1 mr-3"
								:isMobile="false"
							/>
						</div>
						<div v-else class="js-carousel-parent mt-2" style="height: 180px">
							<b-carousel
								id="carousel-assessments"
								:interval="400000"
								:controls="relatedAssessments.length <= 2 ? false : true"
								background="#ffffff"
								img-width="1024"
								img-height="480"
								@sliding-start="onSlideStart"
								@sliding-end="onSlideEnd"
							>
								<b-carousel-slide
									v-for="slideNumber in ceil(relatedAssessments.length / 2)"
									:key="slideNumber"
								>
									<AssessmentCard
										v-for="(assessment, index) in slice(
											relatedAssessments,
											(slideNumber - 1) * 2,
											(slideNumber - 1) * 2 + 2
										)"
										:key="index"
										:assessment="assessment"
										:fromJobSearchpage="true"
										fromJobSearch="details"
										class="carousel-assesspro-cards-1 mb-0"
										:class="index % 2 !== 1 ? 'mr-3' : ''"
									/>
								</b-carousel-slide>
							</b-carousel>
						</div>
					</template>
					<template
						v-if="
							(!relatedJobs || relatedJobs.length) &&
							!jobShimmer &&
							!selectedJob.customFields?.gov_job
						"
					>
						<div class="mb-black-bold mt-2">
							Similar jobs you might be looking for
						</div>
						<div v-if="!relatedJobs" class="d-flex flex-wrap mt-2">
							<div
								v-for="assess in 3"
								:key="assess"
								class="assesspro-cards"
								:class="assess % 3 == 0 ? '' : 'mr-13px'"
							>
								<div class="d-flex">
									<div style="height: 31px; width: 31px">
										<b-skeleton class="h-100 w-100" type="avatar"></b-skeleton>
									</div>
									<div class="width-93 1 pl-2">
										<b-skeleton class="w-50"></b-skeleton>
										<b-skeleton class="w-100"></b-skeleton>
									</div>
								</div>
								<hr />
								<div class="w-100">
									<b-skeleton class="w-100"></b-skeleton>
								</div>
							</div>
						</div>
						<div v-else class="js-carousel-parent mt-2">
							<b-carousel
								:controls="relatedJobs.length <= 3 ? false : true"
								id="carousel-jobs"
								:interval="400000"
								background="#ffffff"
								img-width="1024"
								img-height="480"
								@sliding-start="onSlideStart"
								@sliding-end="onSlideEnd"
							>
								<b-carousel-slide
									v-for="slideNumber in ceil(relatedJobs.length / 3)"
									:key="slideNumber"
								>
									<div
										v-for="(job, index) in slice(
											relatedJobs,
											(slideNumber - 1) * 3,
											(slideNumber - 1) * 3 + 3
										)"
										:key="index"
										class="carousel-assesspro-cards-2 mb-0 pointer"
										:class="index % 3 !== 2 ? 'mr-3' : ''"
										@click="onCarouselJobClick(job)"
									>
										<div class="d-flex">
											<div>
												<img
													src="../../assets/newdesign/jobsearch/roundJobDp.svg"
													alt=""
												/>
											</div>
											<div class="pl-2 width-93">
												<div
													class="d-flex justify-content-between align-items-center w-100"
												>
													<div
														class="mb-blue-txt-3 text-truncate text-left w-75 text-capitalize"
													>
														{{ toTitleCase(job.title) }}
													</div>
													<div
														@click.stop="toggleBookmark(job)"
														:class="index % 2 === 0 ? '' : 'mr-2'"
													>
														<img
															v-if="job.bookmarked"
															class="pointer"
															src="../../assets/newdesign/jobsearch/filledBookmark.svg"
															alt=""
														/>
														<img
															v-else
															class="pointer"
															src="../../assets/newdesign/jobsearch/noFilledBookmard.svg"
															alt=""
														/>
													</div>
												</div>
												<div class="mb-mobile-txt text-left mt-2">
													{{
														job.customFields?.private_job
															? job.customFields?.Board_Organization
															: job.customerName
													}}
												</div>
												<div
													class="d-flex align-items-center cd-hs-pi-sh-2 mt-2"
												>
													<div class="max-w45 text-truncate">
														{{ arrayToString(job.location) }}
													</div>
													<div class="mb-dot ml-2 mr-2"></div>
													<div class="max-w45 text-truncate">
														{{ toTitleCase(job.jobType) }}
													</div>
												</div>
											</div>
										</div>
									</div>
								</b-carousel-slide>
							</b-carousel>
						</div>
					</template>
				</div>
			</section>
			<div class="mobjd-applied-footer w-100 px-3" id="hideinlaptop">
				<div class="mob-cancelBtn w-50 pr-2">
					<b-button class="w-100" @click="goBack">Cancel</b-button>
				</div>
				<div class="mob-addBtn w-50 pl-2">
					<b-button
						@click.stop="
							!hasAccess()
								? openLoginModal()
								: selectedJob.isCurated ||
								  selectedJob.customFields?.gov_job ||
								  selectedJob.customFields?.private_job
								? openGovtJobModal(selectedJob)
								: goToApplyJob(selectedJob)
						"
						class="w-100"
						v-if="!selectedJob.jobApplied && !selectedJob.addedByRecruiter"
						>Apply</b-button
					>
					<b-button v-else disabled class="w-100">Applied</b-button>
				</div>
			</div>
			<!-- Mobile: ApplyJobForm full-screen overlay -->
			<div
				v-if="showApplyJobForm"
				class="mob-applyjob-overlay"
				id="hideinlaptop"
			>
				<ApplyJobForm
					@close="showApplyJobForm = false"
					@success="handleJobApplicationSuccess($event, true)"
					@failure="errorModal('Error', $event), (showApplyJobForm = false)"
					:job="selectedJob"
					:licenseKey="selectedJob.licenseKey"
					:candidateData="candidateData"
					:fromGuestjobdetails="true"
				/>
			</div>

			<!-- Mobile: Complete profile prompt -->

			<div
				v-if="showCompleteProfileModal"
				class="filter-box-mob-3"
				id="hideinlaptop"
			>
				<div class="cyp-container-top-2 cyp-header-txt-2 pl-3">
					Complete your <br />
					profile
					<div class="cyp-dp-pos">
						<img
							height="100"
							src="../../assets/newdesign/jobsearch/cmp-dp.svg"
							alt=""
						/>
					</div>
				</div>
				<div class="w-100 d-flex flex-column align-items-center">
					<div class="cyp-italic-txt">
						To apply for this job, please complete your<br />
						resume first.
					</div>
					<div class="cyp-black-txt my-4">
						Creating a resume on our platform is quick and easy,<br />
						and it will allow you to showcase your skills and<br />
						experience to potential employers.
					</div>
					<div class="mb-3">
						<b-button class="candash-addBtn" @click="goToDashboard"
							>Create your resume now</b-button
						>
					</div>
				</div>
			</div>

			<section id="hideinmobile" class="guest-right-section">
				<JobAlert :isPersistent="!hasAccess()" />
				<div
					class="js-right-second-card p-3 mt-11px"
					v-if="searchHistory && searchHistory.length"
				>
					<img
						class="firstside-pos"
						src="../../assets/newdesign/jobsearch/secondSide.svg"
						alt=""
					/>
					<div class="js-grey-txt">People also searched:</div>
					<div class="js-first-overflow d-flex flex-wrap mt-2">
						<div
							v-for="i in searchHistory"
							:key="i"
							class="js-blue-search-cards mb-2 mr-2 pointer"
							@click="jobSearch(i)"
						>
							<img
								class="mr-2 flex-shrink-0"
								src="../../assets/newdesign/jobsearch/whitesearch.svg"
								alt=""
							/>
							<span class="js-search-tag-text">{{ i }}</span>
						</div>
					</div>
				</div>
				<div class="js-right-third-card p-3 mt-11px" v-if="assessLoader">
					<img
						class="firstside-pos"
						src="../../assets/newdesign/jobsearch/thirdSide.svg"
						alt=""
					/>
					<div class="js-grey-txt">Assessments</div>

					<div class="mt-2 position-relative z-ind-2">
						<AssessmentCardSkeleton
							v-for="assess in 3"
							:key="assess"
							customClass="p-3 mb-2"
							:customStyle="{
								background: '#fcfcfc',
								borderRadius: '8px',
								boxShadow: '0px 2px 8px #00000014',
							}"
						/>
					</div>
				</div>
				<div
					class="js-right-third-card p-3 mt-11px"
					v-else-if="!assessLoader && assessments.length > 0"
				>
					<img
						class="firstside-pos"
						src="../../assets/newdesign/jobsearch/thirdSide.svg"
						alt=""
					/>
					<div class="js-grey-txt">Assessments</div>
					<div class="mt-2 position-relative z-ind-2">
						<AssessmentCard
							v-for="(data, i) in assessments"
							:key="i"
							:assessment="data"
							:fromAsmntprogress="false"
							fromJobSearch="main"
							:fromJobSearchpage="true"
							class="mb-2"
						/>
					</div>
					<div
						class="d-flex justify-content-center w-100 js-underline-txt-2 pointer"
						@click="goToAssessment"
					>
						View All Assessments
					</div>
				</div>
			</section>
			<ApplyJobModal
				v-if="selectedJob && showApplyJob"
				@close="showApplyJob = false"
				@success="handleJobApplicationSuccess"
				@failure="errorModal('Error', $event), (showApplyJob = false)"
				:job="selectedJob"
				:candidateData="candidateData"
				:licenseKey="selectedJob.licenseKey"
			/>
			<Govtjobs
				v-if="govtJobModal"
				@storeid="storeGovtId"
				:showmodal="govtJobModal"
				:selectedJob="selectedJob"
				@close-modal="govtJobModal = false"
			/>
		</main>
	</div>
</template>

<script>
import JobAlert from "@/views/JobSearch/JobAlert.vue";
import AssessmentCard from "@/components/Assessment/AssessmentCard.vue";
import AssessmentCardSkeleton from "@/components/Assessment/AssessmentCardSkeleton.vue";
import ApplyJobModal from "@/components/JobSearch/applyJob.vue";
import Govtjobs from "@/components/JobSearch/GovtJobs.vue";
import ApplyJobForm from "@/views/JobSearch/ApplyJobForm.vue";
import toast from "@/components/mixin/toast";

import {
	getParticularJob,
	getPublicAssessments,
	postJobSearch,
	getGlobalTrending,
	getSearchHistory,
	toggleBookmark,
	getCandidatePrimaryProfile,
	applyJob,
	getCandidateFilePaths,
} from "@/utils/apiFunctions";
import { getCustomFields } from "@/utils/customField.js";
import { mapGetters } from "vuex";
import EventBus from "@/utils/EventBus";
import { hasAccess } from "@/utils/tokenCheck";
import NcdTopContainer from "@/components/NewCandidateDashboard/NcdTopContainer.vue";
import { config } from "@/config/index.js";

export default {
	name: "GuestJobDetails",
	components: {
		JobAlert,
		AssessmentCard,
		AssessmentCardSkeleton,
		ApplyJobModal,
		Govtjobs,
		ApplyJobForm,
		NcdTopContainer,
	},
	mixins: [toast],
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
		...mapGetters("candidateVUEX", {
			candidateProgress: "getCandProgressRespPrimary",
			getgovtids: "getgovtids",
		}),
	},
	mounted() {
		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize);
	},

	async created() {
		await this.createdActions();
		EventBus.$on("login-success", this.createdActions);
		EventBus.$on("onboarding-fetch-post-login", this.createdActions);
	},
	beforeDestroy() {
		EventBus.$off("login-success", this.createdActions);
		EventBus.$off("onboarding-fetch-post-login", this.createdActions);
		window.removeEventListener("resize", this.checkScreenSize);
	},
	data() {
		return {
			jobID: null,
			jobShimmer: false,
			selectedJob: {},
			relatedAssessments: null,
			relatedJobs: [],
			searchHistory: [],
			assessments: [],
			assessLoader: true,
			showApplyJob: false,
			govtJobModal: false,
			candidateData: null,
			showApplyJobForm: false,
			showCompleteProfileModal: false,
			isLaptop: true,
			showAllLocations: false,
			showAllSkills: false,
		};
	},
	methods: {
		goBack() {
			const fromProject = this.$route.query.fromProject;
			const fromPage = this.$route.query.fromPage;

			if (fromProject === "website") {
				window.location.href = fromPage
					? `${config.websiteBase}/${fromPage}`
					: config.websiteBase;
				return;
			} else if (fromProject === "training") {
				window.location.href = fromPage
					? `${config.trainingBase}/${fromPage}`
					: config.trainingBase;
				return;
			} else {
				if (fromPage) {
					this.$router.push({ name: fromPage });
					return;
				}
				this.$router.push({ name: "JobSearch" });
			}
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		hasAccess() {
			return hasAccess();
		},
		openLoginModal() {
			EventBus.$emit("open-login-modal", true);
		},
		async createdActions() {
			if (this.hasAccess()) {
				this.fetchCandidateData();
			}
			this.jobID = this.$route.query.jobID;
			if (this.jobID) {
				await this.fetchJobDetails();
				if (!this.selectedJob.isCurated) this.getTrendingJob(this.jobID);
				// Fetch both sections in parallel and wait for BOTH to finish before showing them
				const [assessments, jobs] = await Promise.all([
					this.fetchRelatedAssessments(true),
					this.fetchRelatedJobs(true),
				]);
				this.relatedAssessments = assessments;
				this.relatedJobs = jobs;
			}
			this.getSearchHistoryData();
			this.getAssessmentsData();
		},
		goToAssessment() {
			this.$router.push({
				name: "CandidateAssessmentProgress",
			});
		},
		jobSearch(searchTerm) {
			this.$router.push({
				name: "JobSearch",
				query: {
					searchQuery: searchTerm,
				},
			});
		},
		async getSearchHistoryData() {
			try {
				const res = await getSearchHistory();
				if (res.status == 200) {
					this.searchHistory = res.data.data;
				} else {
					throw new Error("No search history found");
				}
			} catch (error) {
				console.error(error);
				this.searchHistory = [];
			}
		},
		async getAssessmentsData() {
			try {
				this.assessLoader = true;
				const res = await getPublicAssessments({
					page: 1,
					count: 10,
					email: this.userInfo?.email || "",
					home: true,
				});
				if (res.status == 200) {
					this.assessments = res.data.data.data.filter(
						(assessment) => assessment.attemptsLeft >= 1
					);

					this.assessments = this.assessments.slice(0, 3);
				} else {
					this.assessments = [];
				}
			} catch (error) {
				this.assessments = [];
			} finally {
				this.assessLoader = false;
			}
		},
		// Fetches job details from the backend using the JobID
		async fetchJobDetails() {
			this.jobShimmer = true;
			try {
				const payload = {
					jobID: this.jobID,
					emailID: this.userInfo?.email || "",
				};
				const res = await getParticularJob(payload);
				if (res.status === 200) {
					const job = res.data.data;
					// Normalize isApplied → jobApplied to match template condition
					if (job.jobApplied === undefined && job.isApplied !== undefined) {
						job.jobApplied = job.isApplied;
					}
					// Ensure bookmarked is defined so Vue 2 reactivity tracks it
					if (job.bookmarked === undefined) {
						job.bookmarked = false;
					}
					this.selectedJob = job;
					console.log(this.selectedJob, "selected job");
				}
			} catch (error) {
				console.error("Error fetching job details:", error);
			} finally {
				this.jobShimmer = false;
			}
		},
		toTitleCase(str) {
			if (!str) return "";
			return str.replace(/\w\S*/g, (txt) => {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			});
		},
		async toggleBookmark(job) {
			if (!this.hasAccess()) {
				this.openLoginModal();
				return;
			}
			const newValue = !job.bookmarked;
			this.$set(job, "bookmarked", newValue);
			try {
				const res = await toggleBookmark({
					jobID: job.jobID,
					bookmark: newValue,
				});
				if (res.status === 200) {
					this.successModal(
						"Success",
						newValue ? "Bookmarked Successfully" : "Unbookmarked Successfully"
					);
				}
			} catch (error) {
				this.$set(job, "bookmarked", !newValue);
				console.error(error);
			}
		},
		openGovtJobModal(job) {
			this.selectedJob = job;
			this.govtJobModal = true;
		},
		openApplyJobModal(job) {
			this.selectedJob = job;
			this.showApplyJob = true;
		},
		goToApplyJob(job) {
			// if (this.candidateProgress && this.candidateProgress.progress >= 20) {
				this.selectedJob = job;
				this.showApplyJobForm = true;
			// } else {
			// 	this.showCompleteProfileModal = true;
			// }
		},
		goToDashboard() {
			this.$router.push({ name: "CandidateDashboard" });
		},
		storeGovtId(id) {
			this.$store.commit("candidateVUEX/storegovtids", id);
		},
		removeGovtid(id) {
			this.$store.commit("candidateVUEX/removegovtid", id);
		},
		async appliedGovtjob(jobid) {
			try {
				const customFields = await getCustomFields(
					"5",
					"add",
					this.selectedJob.licenseKey
				);
				let newObject = {};
				if (customFields.length) {
					[, newObject] = customFields;
				}
				const candidateInfo = this.candidateData;
				if (!candidateInfo) return;
				const res1 = await getCandidateFilePaths(candidateInfo._id);
				if (res1.status == 200) {
					candidateInfo.resume = res1.data.data.resumePath;
				}
				Object.assign(newObject, {
					resume: candidateInfo.resume,
					email: candidateInfo.email,
					experince: candidateInfo.totalYearsOfExp,
					name: candidateInfo.fullName,
					phoneNumber: candidateInfo.phoneNumber,
					skills: candidateInfo.skills
						? candidateInfo.skills.map((s) => s.skillName)
						: [],
					otherSource: "Hire3x",
					source: "other",
					customFields: {
						...(newObject.customFields || {}),
						altPhoneNumber: candidateInfo.altPhoneNumber,
						currentCTC: candidateInfo.currentCTC,
						expectedCTC: candidateInfo.expectedCTC,
						gender: candidateInfo.gender,
						willingToRelocate: candidateInfo.willingToRelocate,
						willingToRelocateTo: candidateInfo.willingToRelocateTo,
						noticePeriod: candidateInfo.noticePeriod,
					},
				});
				const payload = {
					emailID: candidateInfo.email,
					jobID: jobid,
					firstName: candidateInfo.firstName,
					lastName: candidateInfo.lastName,
					location: candidateInfo.city,
					phoneNumber: candidateInfo.phoneNumber,
					candidateInfo: {
						...newObject,
						userID: this.userInfo.userID,
					},
				};
				const res = await applyJob(payload);
				if (res.status === 200) {
					this.handleJobApplicationSuccess(jobid);
					this.removeGovtid(jobid);
				} else {
					throw new Error(res.data.data.Detail);
				}
			} catch (error) {
				console.error("Error in appliedGovtjob:", error);
			}
		},
		handleJobApplicationSuccess(jobID) {
			this.successModal("Success", "Applied Successfully");
			this.showApplyJob = false;
			this.showApplyJobForm = false;
			this.selectedJob = { ...this.selectedJob, jobApplied: true };
		},
		async fetchCandidateData() {
			try {
				const res = await getCandidatePrimaryProfile();
				if (res.status === 200) {
					this.candidateData = res.data.data;
				}
			} catch (error) {
				console.error("Error fetching candidate data:", error);
			}
		},
		scrollToChild(refName) {
			const element = this.$refs[refName];
			if (element) {
				element.scrollIntoView({ behavior: "smooth" });
			}
		},
		highlightedSkills(skills) {
			if (!skills) return "";
			return skills.join(", ");
		},
		arrayToString(arr) {
			if (!arr) return "";
			return arr.join(", ");
		},
		goToMockInterview(job) {
			console.log("Navigating to Mock Interview", job);
		},
		goToInterviewPrep(job) {
			console.log("Navigating to Interview Prep", job);
		},
		onSlideStart(slide) {
			console.log("Slide start", slide);
		},
		onSlideEnd(slide) {
			console.log("Slide end", slide);
		},
		ceil(val) {
			return Math.ceil(val);
		},
		slice(arr, start, end) {
			if (!arr) return [];
			return arr.slice(start, end);
		},
		isUpcoming(assessment) {
			return false;
		},
		// Fetches similar jobs based on the current job's skills
		async fetchRelatedJobs(returnOnly = false) {
			try {
				let skills = [];
				if (
					this.selectedJob.skillsToLearn &&
					Array.isArray(this.selectedJob.skillsToLearn) &&
					this.selectedJob.skillsToLearn.length > 0
				) {
					skills = this.selectedJob.skillsToLearn;
				} else if (
					this.selectedJob.skills &&
					Array.isArray(this.selectedJob.skills)
				) {
					skills = this.selectedJob.skills;
				}

				let payload = {
					skills: skills,
					searchQuery: "",
					locations: [],
					experiernce: [],
					jobType: [],
					dateOfPosting: 0,
					page: 0,
					sortBy: "relevance",
					count: 10,
					jobApplied: false,
					home: true,
				};

				let res = await postJobSearch(payload);

				if (res.status === 200) {
					if (returnOnly) return res.data.data.data;
					this.relatedJobs = res.data.data.data;
				}
			} catch (error) {
				console.error("Error fetching related jobs:", error);
				if (returnOnly) return [];
				this.relatedJobs = [];
			}
		},
		// Fetches public assessments that match the job's skills
		async fetchRelatedAssessments(returnOnly = false) {
			try {
				let skills = [];
				// Use specific preparation skills if they exist, otherwise fallback to main job skills
				if (
					this.selectedJob.skillsToLearn &&
					Array.isArray(this.selectedJob.skillsToLearn) &&
					this.selectedJob.skillsToLearn.length > 0
				) {
					skills = this.selectedJob.skillsToLearn;
				} else if (
					this.selectedJob.skills &&
					Array.isArray(this.selectedJob.skills)
				) {
					skills = this.selectedJob.skills;
				}

				const payload = {
					email: this.userInfo?.email || "",
					count: 10,
					home: true,
					skills: skills,
				};

				const res = await getPublicAssessments(payload);
				if (res.status === 200) {
					if (returnOnly) return res.data.data.data;
					this.relatedAssessments = res.data.data.data;
				}
			} catch (error) {
				console.error("Error fetching assessments:", error);
				if (returnOnly) return [];
				this.relatedAssessments = [];
			}
		},
		viewTestDetails(assessment) {
			this.$router.push({
				path: "/testdetails",
				query: {
					testID: assessment.testID,
				},
			});
		},
		viewMarks(assessment) {
			console.log("Viewing Marks", assessment);
		},
		openJobMatch() {
			console.log("Opening Job Match");
		},
		onCarouselJobClick(job) {
			this.$router.push({
				query: { jobID: job.jobID },
			});
			// Re-fetch data for the new job
			this.jobID = job.jobID;
			this.fetchJobDetails();
			this.fetchRelatedAssessments();
			this.fetchRelatedJobs();
		},
		async getTrendingJob(jobID) {
			try {
				let payload = {
					type: "job",
					interactionType: "click",
					referenceID: jobID,
				};
				const response = await getGlobalTrending(payload);
			} catch (error) {
				console.log(error);
			}
		},
	},
	watch: {
		"$route.query.jobID": {
			handler(newVal) {
				if (newVal) {
					this.createdActions();
				}
			},
		},
	},
};
</script>

<style lang="scss">
.guest-job-details {
	//when logout
	background-color: #e9ecef;
	height: calc(100vh - 80px);
	position: relative;
	top: 80px;
	padding: 20px;
	display: flex;
	gap: 25px;
}
.guest-job-details.login-detail {
	//when login
	padding: 15px 15px 15px 75px;
	top: 60px;
	height: calc(100vh - 60px);
}
.guest-job-details {
	.jdprog-trans-main-cont {
		position: relative;
		width: 70%;
		top: unset;
		border-radius: 8px;
		box-shadow: 0px 1px 8px 0px #0000002b;
		height: unset;
	}

	.jdp-trans-overflow-2 {
		height: calc(100vh - 180px);
		overflow-y: auto;
	}

	h3 {
		font-size: 13px;
		font-weight: 700;
		color: #7a7a7a;
	}

	.js-carousel-parent {
		height: 145px;

		// Premium "Magnetic Snap" transition (Weighted movement that clicks into place)
		.carousel-item {
			transition: transform 0.4s cubic-bezier(0.19, 1, 0.22, 1) !important;
		}
	}

	.js-carousel-parent .carousel {
		height: 100%;
	}

	.js-carousel-parent .carousel-inner {
		height: 100%;
	}

	.js-carousel-parent .carousel-item.active {
		height: 100%;
	}

	.js-carousel-parent .carousel-caption {
		display: flex;
		justify-content: space-between;
		z-index: 1;
		left: 0px;
		padding: 0;
		width: 99%;
		height: 100%;
		bottom: 0px;
	}

	.js-carousel-parent .carousel-control-prev {
		width: 6%;
		left: -12px;
		opacity: 1;
		top: 57px;
		height: fit-content;
	}

	.js-carousel-parent .carousel-control-next {
		width: 6%;
		right: -3px;
		opacity: 1;
		top: 57px;
		height: fit-content;
	}

	.js-carousel-parent .carousel-control-prev-icon {
		background-image: url("../../assets/newdesign/jobsearch/carouselLeft.svg") !important;
		width: 40px;
		height: 40px;
		transform: rotate(0deg);
		left: unset !important;
		position: absolute;
		top: unset !important;
	}

	.js-carousel-parent .carousel-control-next-icon {
		background-image: url("../../assets/newdesign/jobsearch/carouselRight.svg") !important;
		width: 40px;
		height: 40px;
		transform: rotate(0deg);
		right: unset !important;
		position: absolute;
		top: unset !important;
	}

	.carousel-assesspro-cards-1 {
		width: calc(50% - 8px) !important;
	}

	.assesspro-cards {
		width: 32% !important;
	}

	.carousel-assesspro-cards-2 {
		width: 32% !important;
	}

	.guest-right-section {
		width: 30%;
		box-shadow: 0px 1px 8px 0px #0000002b;
		border-radius: 8px;
		background-color: #fff;
		padding: 15px;
		overflow: auto;
	}

	.js-right-first-card {
		background: linear-gradient(313.47deg, #c1d3fe 0.05%, #d7e3fc 79.13%);
		position: relative;
		width: 100%;
		/* height: 145px; */
		border-radius: 8px;
		overflow: hidden;
	}

	.firstside-pos {
		position: absolute;
		right: 0px;
		top: 0px;
		z-index: 1;
	}

	.js-right-input .form-control {
		background: #4a73d212;
		border: 1px solid #85a1e0;
		box-shadow: 0px 1px 2px 0px #1018280d;
		border-radius: 8px;
		height: 30px;
		padding: 10px 10px 12px 10px;
		color: #332d2d !important;
		font-size: var(--size-12) !important;
		font-weight: 500 !important;
	}

	.js-right-input .form-control:focus {
		background: #4a73d212;
		border: 1px solid #85a1e0;
		box-shadow: 0px 1px 2px 0px #1018280d;
		border-radius: 8px;
		height: 30px;
		padding: 10px 10px 12px 10px;
	}
}
.js-right-second-card {
	background: linear-gradient(296.7deg, #89c2d9 0.06%, #c4e3ed 100%);
	position: relative;
	width: 100%;
	height: 158px;
	border-radius: 8px;
	overflow: hidden;
}
.js-first-overflow {
	overflow: auto;
	min-height: auto;
	max-height: 105px;
	z-index: 2;
	position: relative;
}

.js-first-overflow::-webkit-scrollbar {
	scroll-behavior: smooth;
	width: 0px !important;
	height: 0px !important;
	background-color: transparent !important;
}

.js-first-overflow {
	-ms-overflow-style: none; /* IE and Edge */
	scrollbar-width: none; /* Firefox */
}
.js-blue-search-cards {
	font-family: "Lato", sans-serif;
	font-size: 12px;
	font-weight: 500;
	color: #ffffff;
	background-color: #3389a4;
	border-radius: 5px;
	display: flex;
	align-items: center;
	padding: 4px 7px;
	height: fit-content;
	min-width: auto;
	max-width: 100%;
	overflow: hidden;
}

.js-search-tag-text {
	display: block;
	flex: 1;
	min-width: 0;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
.js-right-third-card {
	background: linear-gradient(
		133.18deg,
		rgba(187, 222, 251, 0.6) 13.05%,
		rgba(86, 174, 246, 0.6) 89.15%
	);
	border: 0.25px solid #cbcbcb;
	position: relative;
	width: 100%;
	/* height: 145px; */
	border-radius: 8px;
	overflow: hidden;
}

@media (max-width: 1028px) {
	.guest-job-details {
		min-height: calc(100vh - 80px);
		position: relative;
		top: 80px;
		padding: 15px;
		display: block;
		gap: 25px;
	}

	.guest-job-details .jdprog-trans-main-cont {
		position: relative;
		width: 100%;
		padding: 15px;
		height: calc(100dvh - 145px);
		overflow: auto;
		border-radius: 8px 8px 0 0;
	}
	.guest-job-details .pl-3 {
		padding-left: 0px !important;
	}

	.js-carousel-parent {
		height: auto !important;

		.carousel-inner {
			display: block !important;
		}

		.carousel-item {
			display: block !important;
			margin-right: 0 !important;
			position: relative !important;
		}

		.carousel-caption {
			position: relative !important;
			display: block !important;
			left: 0 !important;
			bottom: 0 !important;
			width: 100% !important;
			padding: 0 !important;
			height: auto !important;
			text-align: left !important;
		}

		.carousel-control-prev,
		.carousel-control-next {
			display: none !important;
		}

		.carousel-assesspro-cards-1,
		.carousel-assesspro-cards-2 {
			width: 100% !important;
			margin-right: 0px !important;
			margin-bottom: 20px !important;
		}
	}
	.jdp-black-txt-3.mob-text-blue {
		color: #20639b;
		font-weight: 600;
		font-size: 14px;
		font-family: "Montserrat", sans-serif;
		padding-top: 5px;
	}
	.guest-job-details .jdp-trans-overflow-2 {
		height: calc(100vh - 141px);
		overflow-y: auto;
	}
	.guest-job-details.login-detail {
		padding: 15px;
		top: 0px;
		height: calc(100vh - 60px);
	}
	.guest-job-details.login-detail .jdp-trans-overflow-2 {
		height: calc(100vh - 107px);
		overflow-y: auto;
	}
	.guest-job-details .assesspro-cards.shimmermobileasmntcard {
		width: 100% !important;
	}
	.mobmain-height-wennoacess {
		height: calc(100dvh - 240px) !important;
	}
}
@media (max-width: 1028px) {
	.mob-applyjob-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: #fff;
		z-index: 1000;
		overflow-y: auto;
	}
}
</style>
